import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';

import { MobileDeviceService } from '@app/services/mobile-device.service';
import { Icon } from '@design-system/components/atoms/icon/entities/icon.types';

@Component({
  selector: 'app-home-item-link',
  templateUrl: './home-item-link.component.html',
  styleUrls: ['./home-item-link.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class HomeItemLinkComponent {

  @Input() text: string;
  @Input() icon: Icon;
  @Input() searchType: string;
  @Input() source: string;
  
  @Output() openItem: EventEmitter<void> = new EventEmitter<void>();

  constructor(   
    private readonly router: Router,
    private readonly mobileDeviceService: MobileDeviceService
  ) { }

  get isMobile$(): Observable<boolean> {
    return this.mobileDeviceService.isMobileDevice$;
  }

  public onClick(): void {
    this.isMobile$.subscribe(isMobile => {
      if (isMobile) {
        this.openItem.emit();
      } else {
        this.router.navigate(
          ['/'],
          {
            queryParams: { SOURCE: this.source },
            state: {
              searchType: this.searchType
            }
          });
      }
    }).unsubscribe();
  }
}
